import PropTypes from 'prop-types'
import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap"
import { Link } from "react-router-dom"
// import  Util  from "./Common/Util"
import Util from 'pages/Dashboard/Common/Util';

import moment from 'moment';
import { useHistory } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Pagination from "pages/Custom/Pagination";

// import images
import client from "../../assets/images/client.png";
import transactionAmount from "../../assets/images/transactionAmount.png";
import transactionPrice from "../../assets/images/transactionPrice.png";
import tradeHistory from "../../assets/images/거래내역.jpg";
import img1 from "../../assets/images/small/img-1.jpg"
import defaultImg from "../../assets/images/default.png"
import loading from "../../assets/images/loading.gif";

// Charts
import LineAreaChart from "../AllCharts/apex/lineareachart";
import ChartistGraph from 'react-chartist';

import "chartist/dist/scss/chartist.scss";

import { useSelector } from 'react-redux';

import { dashboardResponse, getProductList, getSellProductList, mainResponse, newsResponse } from 'crud/auth.crud';
import { useEffect } from 'react';

const style = { fontSize: 14 };

const clickedStyle = { backgroundColor: "#48C3B1", color: "#ffffff" };

const SellList = props => {
  const history = useHistory()
  const selector = useSelector(state => state)
  const newDate = new Date()

  const [isFetching, setIsFetching] = useState(false)
  const [isListEnd, setIsListEnd] = useState(false)
  const [page, setPage] = useState(1)
  const [companyCount, setCompanyCount] = useState();
  const [collectSum, setCollectSum] = useState();
  const [collectMoneySum, setCollectMoneySum] = useState();
  const [newsList, setNewsList] = useState();
  const [isRefresh, setIsRefresh] = useState(false)
  const [dataList, setDataList] = useState([])
  const [searchText, setSearchText] = useState('')
  const [search, setSearch] = useState('')
  const [exchangeState, setExchangeState] = useState('sell')
  // 드롭다운
  const [settingMenu, setSettingMenu] = useState(false)

  const [onUpload, setOnUpload] = useState(false);
  const [pagesGroup, setPagesGroup] = useState(1)
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4])
  const [contentCount, setContentCount] = useState()

  // 상품목록 가져오는 용
  const getDataList = async () => {
    setOnUpload(true)

    let params = {
      page: page,
      search: searchText
    }

    const response = await getSellProductList(params);
    let dataCount = response.data.count % 15 === 0 ? response.data.count / 15 : Math.floor(response.data.count / 15) + 1
    if (!contentCount || contentCount !== dataCount) {
      if(dataCount === 0){
        setContentCount(1)
      }else{
        setContentCount(dataCount)
      }
      let newArr = []
      for (let i = pagesGroup - 1; i < pagesGroup + 4; i++) {
        if (i + 1 <= dataCount) {
          newArr.push(i + 1)
        }
      }
      if(newArr.length === 0) newArr = [1]
      setPageArr(newArr)
    }
    const content = response.data?.results || [];
    if (content.length > 0) {
      setDataList([...content])
    } else {
      setIsListEnd(true)
      setDataList([])
    }
    setOnUpload(false)
  }

  const setPrice = (price) => {
    return Math.round(price)?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  useEffect(() => {
    getDataList();
  }, [])

  useEffect(() => {
    getDataList();
  }, [searchText, page])

  const clickList = (item) => {
    // setDetailData({...item});
    const url = {
      pathname: `/sell-detail-screen`,
      state: { ...item }
    }
    history.push(url);
  }

  return (
    <React.Fragment>
    <div className="page-content">
      <MetaTags>
        <title>거래소 | 웨이스트버스</title>
      </MetaTags>
      <Container fluid>
        <Row>
          <Breadcrumbs maintitle="Home" title="거래소" breadcrumbItem="상품 리스트" />

          <Col sm={12}>
            <div className="float-start btn-group" style={{height: 38}}>
              <Button
                type="button"
                size="sm"
                className={exchangeState == 'sell' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                onClick={() => {
                  setExchangeState('sell')
                  props.stateChange("sell")
                }}
              >
                판매리스트
              </Button>
              <Button
                type="button"
                size="sm"
                className={exchangeState == 'buy' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                onClick={() => {
                  setExchangeState('buy')
                  props.stateChange("buy")
                }}
              >
                구매리스트
              </Button>
            </div>
          </Col>

          <Col sm={12}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="position-relative app-search d-none d-lg-block">
                <input
                  className="form-control"
                  placeholder="검색어를 입력해주세요..."
                  onChange={(e) => {
                    setSearch(e.target.value.length == 0 ? '' : e.target.value)
                  }}
                  onKeyPress={(e) => {
                    if (e.key == 'Enter') {
                      setSearchText(search)
                    }
                  }}
                />
                <span onClick={() => {
                  setSearchText(search)
                }} className="fa fa-search" style={{ lineHeight: '36px', cursor: 'pointer' }} />
              </div>
              <div className="waver-pagination-btn-group" >
                <button className="waves-effect submit-btn btn btn-secondary margin-left-6 font-size-16"
                  onClick={() => {
                    history.push('/buy-request-write')
                  }} >구매등록</button>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          {dataList.length > 0 && dataList.map((item, index) => {
            return (
              <Col className='pointer' xl={4} md={6} key={index} onClick={() => { clickList(item) }}>
                <Card className="directory-card">
                  <CardBody>
                    <div className="d-flex">
                      <img
                        src={"http://wasteverse.ropiklabs.com" + item.trade_file?.[0]?.path}
                        alt="사진"
                        className="img-fluid avatar-lg"
                        style={{ borderRadius: '4px' }}
                        onError={(e) => e.target.src = defaultImg}
                      />
                      <div className="flex-1 ms-4 d-flex flex-column justify-content-between">
                        <div>
                          <h5 className="font-size-18 mt-0 mb-1 text-black">
                            {item.subject ? item.subject : ''}
                          </h5>
                          <p className='font-size-14 text-gray pt-1'>재고: {Util.setPrice(item.qty)}kg</p>
                        </div>
                        <div className='d-flex align-items-center justify-content-end'>
                          <div className={`waves-effect waves-light ${item.state === 'U' ? 'bg-primary' : item.state === 'N' ? 'bg-white' : 'bg-gray'} exchange-tag text-white font-size-12 margin-right-8`}>{item.state === 'U' ? '거래중' : item.state === 'N' ? '' : '거래완료'}</div>
                          <p className="mb-0 text-end font-size-14">kg당 <span className='font-size-22 font-weight-bold'>{Util.setPrice(item.price_per_kg)}</span>원</p>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )
          })
          }
          {dataList.length === 0 &&
            <Col xl={4} md={6}>
            <Card className="directory-card">
              <CardBody>
                <div className="d-flex">
                  <img
                    src={defaultImg}
                    alt="사진"
                    className="img-fluid avatar-lg"
                    style={{ borderRadius: '4px' }}
                  />
                  <div className="flex-1 ms-4 d-flex flex-column justify-content-between">
                    <div>
                      <h5 className="font-size-18 mt-0 mb-1 text-black">
                        {'상품이 존재하지 않습니다.'}
                      </h5>
                      <p className='font-size-14 text-gray pt-1'>재고: - kg</p>
                    </div>
                    <div className='d-flex align-items-center justify-content-end'>
                      <p className="mb-0 text-end font-size-14">kg당 - 원</p>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
            }
        </Row>
        <Pagination contentCount={contentCount} pageArr={pageArr} pageCallBack={(page)=>{setPage(page)}} />
      </Container>
    </div>
    {onUpload && <div style={{
      position: "absolute",
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background: 'rgba(255, 255, 255, 0.6)',
      zIndex: 999,
      display: "flex",
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <img src={loading} alt="로딩중입니다." width={'5%'}></img>
    </div>}

    </React.Fragment>
  )
}

export default SellList
